import indexOf from 'lodash/indexOf';
export const _indexOf = indexOf;
